import isMobile from 'ismobilejs';

export default new class UserAgentDetector {
  constructor() {
    this.isMobile = isMobile(window.navigator);
  }

  get isIOSSafari() {
    return this.isMobile.apple.phone && navigator.vendor && navigator.vendor.indexOf("Apple") > -1 && navigator.userAgent && -1 === navigator.userAgent.indexOf("CriOS") && -1 === navigator.userAgent.indexOf("FxiOS");
  }

  get isChrome() {
    return /Chrome|CriOS/i.test(window.navigator.userAgent) && !/Edg/i.test(window.navigator.userAgent) && !/OPR|OPM|OPT|Opera/i.test(window.navigator.userAgent);
  }

  get isFirefox() {
    return /Firefox|FxiOS/i.test(window.navigator.userAgent);
  }

  get isSafari() {
    return /Safari/i.test(window.navigator.userAgent)
      && !/Chrome|CriOS|FxiOS|Edg|OPR|OPM|OPT|Opera/i.test(window.navigator.userAgent)
      && /Version/i.test(window.navigator.userAgent);
  }

  get isEdge() {
    return /Edg|EdgiOS/i.test(window.navigator.userAgent);
  }

  get isOpera() {
    return /OPR|OPM|OPT|Opera|Opera Mini/i.test(window.navigator.userAgent);
  }

  get isOperaMini() {
    return /Opera Mini|OPM/i.test(window.navigator.userAgent);
  }

  get browserName() {
    if (this.isChrome) return "Chrome";
    if (this.isFirefox) return "Firefox";
    if (this.isSafari) return "Safari";
    if (this.isEdge) return "Edge";
    if (this.isOpera) return "Opera";
    return "Unknown";
  }

  checkBrowser() {
    console.warn('checkBrowser is deprecated');
  }
}
